import React, { useEffect } from "react"
import { Editor } from "core/editor"
import { ElementToolbar } from "app/editor/element-toolbar"
import { Plugins } from "app/editor/plugins"
import { useBlocks } from "../../hooks/use-blocks"
import { usePageData } from "../../hooks/use-page-data"
import { useSlateValue } from "../../hooks/use-slate-value"
import { Value } from "@convertkit/slate"
import { defaultSlateValue } from "./default-slate-value"
import { Block } from "../shared/block"

const plugins = Plugins()

// The purpose of `_editors` is to provide access to the Slate Editor object
// for each of the editors that has ever been focused on a page.
export const _editors = {}

export const isImmutable = value => Boolean(value?._map)

export function Text({ id }) {
  const { properties, update } = useBlocks(id)
  const { location } = usePageData()
  const value = useSlateValue(properties.value, update)

  // `value_html` and `value_plain` should be derived from `value` when needed.
  // To do this, you can use the utility functions in this directory.
  const onChange = ({ value }) => {
    update({ value })
  }

  // Add a value if the editor doesn't already have one. This places an empty
  // paragraph in the editor and prevents parsing errors.
  useEffect(() => {
    if (!properties.value) {
      update({ value: Value.fromJSON(defaultSlateValue) })
    }
  }, [properties.value, update])

  // When an editor is focused, we push its editor object into `_editors` so it
  // can be referenced elsewhere on the page.
  function updateRefs(editorRef) {
    _editors[id] = editorRef
  }

  return (
    <Block id={id}>
      <Editor
        placeholder="Add content..."
        onChange={onChange}
        plugins={plugins}
        value={value}
        schema={null}
        location={location}
        target="email"
        className="spaced-contents"
        onFocus={updateRefs}
      >
        <ElementToolbar />
      </Editor>
    </Block>
  )
}
